import { httpClient } from '../lib/http-client';

/**
 * Service para gerenciamento de push notifications
 */
export class PushService {
  static async testPushNotification(data: {
    titulo: string;
    mensagem: string;
    dados?: any;
  }): Promise<{ success: boolean; message: string }> {
    return httpClient.post<{ success: boolean; message: string }>('/api/push/teste', data);
  }

  static async registerPushSubscription(subscription: {
    endpoint: string;
    keys: { p256dh: string; auth: string };
  }): Promise<{ success: boolean; message: string }> {
    return httpClient.post<{ success: boolean; message: string }>(
      '/api/push/registrar',
      subscription
    );
  }

  static async unregisterPushSubscription(): Promise<{ success: boolean; message: string }> {
    return httpClient.delete<{ success: boolean; message: string }>('/api/push/remover');
  }

  static async getVapidPublicKey(): Promise<{
    success: boolean;
    public_key: string;
    message: string;
  }> {
    return httpClient.get<{ success: boolean; public_key: string; message: string }>(
      '/api/push/vapid-public-key'
    );
  }

  static async diagnosticoPushNotifications(): Promise<{ success: boolean; diagnostico: any }> {
    return httpClient.get<{ success: boolean; diagnostico: any }>('/api/push/diagnostico');
  }

  static async getPushStatus(): Promise<{
    success: boolean;
    hasActiveSubscription: boolean;
    totalDevices: number;
    devices: string[];
  }> {
    return httpClient.get<{
      success: boolean;
      hasActiveSubscription: boolean;
      totalDevices: number;
      devices: string[];
    }>('/api/push/status');
  }

  static async registerPushSubscriptionWithDevice(subscription: {
    endpoint: string;
    keys: { p256dh: string; auth: string };
    device_id?: string;
    device_name?: string;
    user_agent?: string;
  }): Promise<{ success: boolean; message: string }> {
    return httpClient.post<{ success: boolean; message: string }>(
      '/api/push/registrar',
      subscription
    );
  }
}

